export const  enums ={
  genderList:[
    {name: '男', code: 1},
    {name: '女', code: 2},
  ],
  idCardTypes:[
    {label: '居民身份证', value: 1},
    {label: '儿童无身份证件', value: 2},
    {label: '护照', value: 3},
    {label: '港澳居民身份证', value: 4},
    {label: '台湾居民来往内地通行证', value: 5},
    {label: '其他法定有效证件', value: 6},
  ],
  resideConditionList :[
    {name: '常住', code: 1},
    {name: '暂住', code: 2},
  ],
  occupancyTypeList :[
    {name: '随父', code: 1},
    {name: '随母', code: 2},
    {name: '未入户', code: 3},
  ],
  resideTypeList :[
    {name: '本市', code: 1},
    {name: '本省非本市', code: 2},
    {name: '非本省', code: 3},
  ],
  educationalLevelList :[
    {name: '本科', code: 1},
    {name: '普通专升本', code: 2},
    {name: '专科', code: 3},
  ],
  pastMedicalHistoryList:[
    {value: '无', code: "1"},
    {value: '先天性心脏病', code: "2"},
    {value: '癫痫', code: "3"},
    {value: '高热惊厥', code: "4"},
    {value: '哮喘', code: "5"},
    {value: 'G-6PD缺陷病', code: "6"},
    {value: '其他', code: "7"},
  ],
  allergyHistoryList:[
    {value: '无', code: 1},
    {value: '有', code: 2}
  ],
  infectionHistoryList:[
    {value: '无', code: 1},
    {value: '有', code: 2}
  ],
  familyMemberTypeList:[
    {value: '父亲', code: 1},
    {value: '母亲', code: 2},
    {value: '子女', code: 3},
    {value: '其他', code: 4},
    {value: '配偶', code: 5}
  ],
  occupationsList:[
    {value: '国家机关、党群组织、企业、失业单位负责人', code: 1},
    {value: '专业技术人员', code: 2},
    {value: '办事人员和有关人员', code: 3},
    {value: '商业、服务业人员', code: 4},
    {value: '农、林、牧、渔、水利业生产人员', code: 5},
    {value: '生产、运输设备操作人员及有关人员', code: 6},
    {value: '军人', code: 7},
    {value: '不便分类的其他从业人员', code: 8},
    {value: '无职业', code: 9}
  ],
  businessTypeIds:[
    {label: '全部', value: ''},
    {label: '学生入学体检', value: 1},
    {label: '小学入学体检', value: 2},
    {label: '中学生入学体检', value: 3},
    {label: '大学生入学体检', value: 4},
    {label: '孕产妇产前体检', value: 5},
    {label: '儿保门诊', value: 6},
    {label: '0-6岁儿童体检', value: 7},
  ],
  collectionStatus:[
    {label: '全部', value: ''},
    {label: '待收表', value: 1},
    {label: '已收表', value: 2},
    {label: '取消收表', value: 3},
  ],
  globalCheckStatus:[
    {label: '全部', value: ''},
    {label: '未检', value: 1},
    {label: '请假', value: 2},
    {label: '漏项', value: 3},
    {label: '已完成', value: 4},
  ],
  publishStatus:[ //发布状态;1:未发布,2:已发布
    {label: '全部', value: ''},
    {label: '未发布', value: 1},
    {label: '已发布', value: 2},
  ],
  status:[
    {label: '启用', value: 1},
    {label: '禁用', value: 2},
  ],
  organizeTypes:[
    {label: '外送', value: 1},
    {label: '自检', value: 2},
  ],
  stopTypes:[
    {label: '停用', value: 1},
    {label: '开启', value: 2},
  ],
  categories:[
    {label: '一般检查', value: 1},
    {label: '眼科', value: 2},
    {label: '五官科', value: 3},
    {label: '外科', value: 4},
    {label: '内科', value: 5},
    {label: '未分类', value: 6},
  ],
  elementTypes:[
    {label: '文本', value: 1},
    {label: '整数', value: 2},
    {label: '小数', value: 3},
    {label: '单选', value: 4},
    {label: '单选+备注', value: 5},
    {label: '复选框', value: 6},
    {label: '复选框+备注', value: 7},
    {label: '下拉框单选', value: 8},
    {label: '下拉框单选+备注', value: 9},
    {label: '多选下拉框', value: 10},
    {label: '多选下拉框+备注', value: 11},
    {label: '日期', value: 12},
    {label: '年份', value: 13},
    {label: '年月', value: 14},
    {label: '多行文本', value: 15},
    {label: '链接', value: 16},
  ],
  /*elementTypes:[
    {label: 'text(input)', value: 1},
    {label: 'number(input)', value: 2},
    {label: 'digit(input)', value: 3},
    {label: 'radio(单选)', value: 4},
    {label: 'radioMarkBox(单选+)', value: 5},
    {label: 'checkBox', value: 6},
    {label: 'checkMarkBox(复选框+备注)', value: 7},
    {label: 'selection(下拉单选)', value: 8},
    {label: 'selectionMarkBox(下拉单选+备注)', value: 9},
    {label: 'multipleSelect(多选下拉)', value: 10},
    {label: 'multipleSelectMarkBox(多选下拉+备注)', value: 11},
    {label: 'calendar(日期)', value: 12},
    {label: 'year(年份)', value: 13},
    {label: 'year_month(年月)', value: 14},
    {label: 'textarea', value: 15},
    {label: 'a链接', value: 16},
  ],*/
  columnNumbers:[
    {label: '一行两列', value: 6},
    {label: '一行一列', value: 12},
  ],
  nodeTypes:[
    {label: '普通选项', value: 1},
    {label: '树形选项', value: 2},
  ],
  isOrNot:[
    {label: '否', value: 1},
    {label: '是', value: 2},
  ],
  defaultDate:[
    {label: '体检当天', value: 1},
    {label: '体检明年当天', value: 2},
    {label: '自定义日期', value: 3},
  ],
  pysicalList:[
    {label: '是', value: 1},
    {label: '否', value: 2},
  ],
  physicalProjectTypes:[
    {label: '普通项目', value: 1},
    {label: 'DR项目', value: 2},
  ],
  projectTypes:[
    {label: '默认项目', value: 1},
    {label: '自费项目', value: 2},
    {label: '加做项目', value: 3},
  ],
  sourcesList:[
    {label: '全部', value: ''},
    {label: '自主创建', value: 1},
    {label: '运营创建', value: 2},
  ],
  lisTypes:[
    {label: '组合', value: 1},
    {label: '单项', value: 2},
  ],
  lisProjectTypes:[
    {label: '默认项目', value: 1},
    {label: '自选项目', value: 2},
  ],
  exportResults:[
    {label: '全部成功', value: 1},
    {label: '部分成功', value: 2},
    {label: '全部失败', value: 3},
    {label: '导入中', value: 4},
  ],
  exportTypes:[
    {label: '班级导入', value: 1},
    {label: '导入学生', value: 2},
    {label: '导入体检名单', value: 3},
    {label: '导入检验数据', value: 4},
    {label: '导入DR图片', value: 5},
    {label: '导入DR结果', value: 6},
  ],
  checkStatusList:[
    {label: '全部', value: ''},
    {label: '未检查', value: 1},
    {label: '已检查', value: 2},
    {label: '部分检查', value: 3},
  ],
  inspectStatusList:[
    {label: '待推送', value: 1},
    {label: '推送成功', value: 2},
    {label: '推送失败', value: 3},
    {label: '取消成功', value: 4},
    {label: '取消失败', value: 5},
    {label: '接收成功', value: 6},
    {label: '接收不完整', value: 7},
    {label: '接收失败', value: 8},
    {label: '导入不完整', value: 9},
    {label: '导入成功', value: 10},
  ],
  //学生管理

}
